import React from 'react';
import Container from '../atoms/Container';
import styled from 'styled-components';
import WalterLogo from '../../assets/walter-logo.inline.svg';
import UpArrow from '../../assets/up-arrow.inline.svg';
import SubscribeForm from '../atoms/SubscribeForm';
import { Link, StaticQuery, graphql } from 'gatsby';
import scrollTo from 'gatsby-plugin-smoothscroll';
import MarkdownConverter from '../atoms/MarkdownConverter';

const Holder = styled.div`
  margin-top: 4rem;
  @media( ${props => props.theme.breakpoints.md} ) {
    margin-top: 8rem;
  }
`;

const PreFooter = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 2rem;
  grid-auto-flow: dense;
  margin-bottom: 4rem;
  position: relative;
  @media( ${props => props.theme.breakpoints.sm} ) {
    grid-template-columns: 1fr 1fr;
  }
  .walter-holder {
    max-width: calc(100% - 4rem);
    svg {
      width: 16rem;
      height: auto;
      display: block;
      margin-top: 1rem;
    }
  }
  .subscribe-holder {
    grid-column: 1/2;
    @media( ${props => props.theme.breakpoints.sm} ) {
      grid-column: 2/3;
    }
  }
  button.scroll-to-top {
    position: absolute;
    top: 0;
    right: 0;
    width: 2rem;
    transition: transform 0.25s;
    &:hover {
      transform: translateY(-0.5rem);
    }
  }
  p { margin-top: 0; }
`;

const Foot = styled.footer`
  display: grid;
  margin-bottom: 4rem;
  grid-row-gap: 2rem;
  @media( ${props => props.theme.breakpoints.sm} ) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media( ${props => props.theme.breakpoints.md} ) {
    grid-template-columns: 1fr 1fr 2fr;
  }
  p:first-child { margin-top: 0; }
  ul {
    list-style: none;
    padding-left: 0;
  }
`;

const PostFooter = styled.div`
`;

function Footer() {
  return (
    <StaticQuery
      query={graphql`
            query FooterQuery {
              contentfulGlobalSettings {
                footerAddress {
                  footerAddress
                }
                footerSocialLinks {
                  footerSocialLinks
                }
              }
            }
          `}
      render={data => (
        <Holder>
          <Container>
            <PreFooter>
              <div className="walter-holder">
                <p className="smallcaps">Walter Café & Kiosk also welcomes you from December 2021</p>
                <WalterLogo/>
              </div>
              <div className="subscribe-holder">
                <p className="smallcaps">Subscribe for Updates</p>
                <SubscribeForm/>
              </div>
              <button aria-label="Submit" className="scroll-to-top icon small" onClick={() => scrollTo( '#top' )}>
                <UpArrow/></button>
            </PreFooter>
            <Foot>
              <div>
                <p className="smallcaps">Find us</p>
                <MarkdownConverter content={data.contentfulGlobalSettings.footerAddress.footerAddress}/>
              </div>
              <div>
                <p className="smallcaps">Follow us</p>
                <MarkdownConverter content={data.contentfulGlobalSettings.footerSocialLinks.footerSocialLinks}/>
              </div>
              <div>
                <p className="smallcaps">Site</p>
                <ul>
                  <li><Link to="/functions-and-events/">Functions & Events</Link></li>
                  <li><Link to="/the-restaurant/">The Restaurant</Link></li>
                  <li><Link to="/about-the-marion/">About The Marion</Link></li>
                  <li><Link to="/contact/">Contact</Link></li>
                  <li><Link to="/privacy-policy/">Privacy Policy</Link></li>
                </ul>
              </div>
            </Foot>
            <PostFooter>
              <p>The Marion & Walter are proudly presented by the Grand Pacific Group</p>
            </PostFooter>
          </Container>
        </Holder>
      )}
    />

  )
}

export default Footer;
